(function ($) {

    /* use/init Chosen library for the Historical form */
    if ($(".historical-form")) {
        let select = $(".historical-form select");

        function chosenSelectInit() {
            select.chosen({
                allow_single_deselect: true,
                width: '344px'
            });
        }

        chosenSelectInit();
    }

    let ratesHelpers = {
        numberWithSemicolon: function (num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    };

    let ratesModal = {
        vars: function () {
            this.modal = $(".rates-modal");
            this.modalContent = this.modal.find(".modal-content");
            this.closeBtn = this.modal.find(".close-modal");
        },

        openModal: function () {
            ratesModal.modal.addClass("active");

            /* make body "no scroll" when the modal is open */
            scrollDistance = $(window).scrollTop();
            $("body").addClass("no-scroll").css("top", scrollDistance * -1);
        },

        closeModal: function () {
            ratesModal.modal.removeClass("active");

            $("body").removeClass("no-scroll").css("top", "");
            $(window).scrollTop(scrollDistance);
        },

        events: function () {
            /* close modal on close Button click */
            ratesModal.closeBtn.on("click", ratesModal.closeModal);

            /* close modal on click outside*/
            $(document).on("click", function (e) {
                if (ratesModal.modal.hasClass("active") && $(e.target).find(ratesModal.modalContent).length !== 0) {
                    $(e.target).closest(ratesModal.modal).removeClass("active");
                    $("body").removeClass("no-scroll").css("top", "");
                    $(window).scrollTop(scrollDistance);
                }
            });

            /* close modal on ESC click */
            $(document).on("keydown", function (e) {
                if (ratesModal.modal.hasClass("active") && e.keyCode === 27) {
                    ratesModal.closeModal()
                }
            });
        },
    };

    let ratesRequests = {
        getData: function (state, year) {
            var year_arr = [];
            year_arr[0] = year;
            $.ajax({
                url: "/wp-admin/admin-ajax.php?action=get_statistic",
                type: "POST",
                data: {
                    state_id: state,
                    year_id: year_arr
                },
                beforeSend: function (xhr) {
                    $(".loader").show();
                },
                success: function (response) {
                    if (response) {
                        let ratesBlockForInsertData = $("#rates .historical-rates-ajax");
                        ratesBlockForInsertData.empty().html(response);

                        /* add a scroll to the block with the output of the response when choosing a year and country selects */
                        setTimeout(function() {
                            $('html, body').animate({
                                scrollTop: $("#rates .historical-rates-ajax").offset().top - $(".site-header").outerHeight() - 25
                            }, 800);
                        }, 1000)

                        /* add a "scroll to selects" link under the tables with response data */
                        if ($(".rates-another-choice").length < 1) {
                            ratesBlockForInsertData.append("<a href=\"#choose-state-year-form\" class=\"rates-another-choice\">Choose a different year or state" +
                                "<svg width=\"11\" height=\"10\" viewBox=\"0 0 11 10\" fill=\"transparent\">\n" +
                                "<path d=\"M-3.69028e-08 8.59619L0.831706 9.41423L5.22721 4.95264L9.62386 9.44043L10.4578 8.62467L5.22949 3.28809L-3.69028e-08 8.59619ZM0.00455711 5.19189L0.827148 6.01904L5.23177 1.63949L9.63297 5.94954L10.4487 5.11556L5.22493 -2.28389e-07L0.00455711 5.19189Z\"/>\n" +
                                "</svg>" +
                                "</a>");

                            $(".historical-rates").on("click", ".rates-another-choice", function() {
                                $('html, body').animate({
                                    scrollTop: $($.attr(this, 'href')).offset().top - $(".site-header").height() - 50
                                }, 500);
                            });
                        }

                        /* add an animated arrow "Scroll tables" above the tables with response data */
                        if ($(".scroll-arrow").length < 1) {
                            ratesBlockForInsertData.find(".btn-bar").before("<div class=\"scroll-arrow\">\n" +
                                "      <div class=\"scroll-arrow__text\">\n" +
                                "      Please scroll\n" +
                                "     </div>\n" +
                                "      <div class=\"scroll-arrow__wrapper\">\n" +
                                "        <div class=\"scroll-arrow__body\">\n" +
                                "        </div>\n" +
                                "        <div class=\"scroll-arrow__head\"></div>\n" +
                                "      </div>\n" +
                                "    </div>");
                        }
                    }
                },
                complete: function (xhr, textStatus) {
                    $(".loader").hide();
                },
                error: function (xhr, textStatus) {
                    console.log("Request failed: " + textStatus);
                }
            });
        },
        getDataCost: function (state) {
            $.ajax({
                method: "GET",
                url: "/wp-admin/admin-ajax.php",
                data: {
                    action: "historic_rates_estimator",
                    state_id: state
                },
                beforeSend: function (xhr) {
                    $(".loader").show();
                },
                success: function (response) {
                    if (response) {
                        let data = response.data;

                        $("#rate-cost-internal-medicine .inserted-data").empty().html("$" + ratesHelpers.numberWithSemicolon(data.internal_medicine_rate));
                        $("#rate-cost-general-surgeon .inserted-data").empty().html("$" + ratesHelpers.numberWithSemicolon(data.general_surgeon_rate));
                        $("#rate-cost-ob-gyn .inserted-data").empty().html("$" + ratesHelpers.numberWithSemicolon(data.obgyn_rate));
                        $("#rate-cost-link .inserted-data").empty().html(data.state_name);
                        $("#rate-cost-link a").attr("href", "/medical-malpractice-insurance-by-state/" + data.state_slug);


                        setTimeout(function () {
                            $(".historical-cost-info").fadeIn();
                        }, 200)
                    }
                },
                complete: function (xhr, textStatus) {
                    $(".loader").hide();
                },
                error: function (xhr, textStatus) {
                    console.log("Request failed: " + textStatus);
                }
            });
        },
    }

    let ratesPageView = {

        checkSelectValue: function () {
            let ratesStateSelect = $("#historical-rates-states");
            let ratesYearSelect = $("#historical-rates-years");
            let costStateSelect = $("#historical-cost-states");

            function updateDataOnSelectChange(select, blockWithData) {
                select.on("change", function () {
                    var selectedValue = $(this).find('option:selected').val();

                    $(this).trigger("chosen:updated");

                    if (selectedValue === "") {    /* if the select is empty (option not selected) */
                        if(select === costStateSelect ) {
                            blockWithData.fadeOut();
                        } else if (select === ratesStateSelect || select === ratesYearSelect) {
                            blockWithData.empty();
                        }
                        return false
                    } else {     /* if the select has value (option is selected) --> make a request*/
                        if(select === costStateSelect ) {
                            ratesPageView.requestStateCost();
                        } else if (select === ratesStateSelect || select === ratesYearSelect) {
                            ratesPageView.requestStateAndYear();
                        }
                        return false
                    }
                });
            }

            updateDataOnSelectChange(ratesStateSelect, $("#rates .historical-rates-ajax"));
            updateDataOnSelectChange(ratesYearSelect, $("#rates .historical-rates-ajax"));
            updateDataOnSelectChange(costStateSelect, $("#cost .historical-cost-info"));

        },

        requestStateAndYear: function() {
            var state = $("#choose-state-year-form #historical-rates-states option:selected").val();
            var year = $("#choose-state-year-form #historical-rates-years option:selected").val();

            if (state && year) {
                ratesRequests.getData(state, year);
            }
        },

        requestStateCost: function () {
            var stateForCost = $("#historical-cost-states option:selected").val();

            if (stateForCost) {
                ratesRequests.getDataCost(stateForCost);
            }
        },

        callRatesModal: function() {
            if( $("#cost") ) {
                $(".historical-cost-info").on("click",".historical-cost-modal-link", function() {
                    ratesModal.vars();
                    ratesModal.openModal();
                    ratesModal.events();
                })
            }

        },

        init: function () {
            ratesPageView.checkSelectValue();
            ratesPageView.requestStateCost();
            ratesPageView.requestStateAndYear()
            ratesPageView.callRatesModal();
        }
    }

    ratesPageView.init();

})(jQuery);
